import React from 'react';

const MenuWrapper: React.FC = ({children}) => {
  return <div className={'agenda__service'}>{children}</div>;
};

export default MenuWrapper;
